import { RefObject, useEffect, useRef } from "react";
import Script from "next/script";
import { Typography } from "@mui/material";
import { Box, CircularProgress } from "@mui/material";
import ConfirmModal from "../ConfirmModal";
import { useTranslation } from "react-i18next";
import useTourBooking from "@/hooks/useTourBooking";
import { tourBookingService } from "@/services/tourBookingService";
import { useTourBookingContext } from "@/containers/TourBookingByCustomer/providers/useTourBookingContext";
import PreLoading from "../PreLoading";

export type PayPalPaymentModalProps = {
  paypalRef?: any;
  isOpen: boolean;
  renderPaypalButtons: () => void;
  onClose: () => void;
  paypalOrderId: string | undefined;
  paypalPaymentApproved: boolean;
}

export default function PayPalPaymentModal({ paypalRef, isOpen, renderPaypalButtons, onClose, paypalOrderId, paypalPaymentApproved }: PayPalPaymentModalProps) {
  const { t } = useTranslation('common');

  const { finishRenderPaypalButtons, setFinishRenderPaypalButtons } = useTourBookingContext();

  useEffect(() => {
    function handleCheckRefToRenderPaypalButtons() {
      const currentPaypalEl = paypalRef?.current;
      const findPaypalIFrame = currentPaypalEl?.querySelector('iframe');

      if (currentPaypalEl && findPaypalIFrame) {
        return;
      }

      if (isOpen && paypalRef?.current && window.paypal) {
        renderPaypalButtons();
      }
    }

    setTimeout(() => {
      handleCheckRefToRenderPaypalButtons();
    }, 300);
  }, [isOpen, paypalRef, renderPaypalButtons]);

  function handleClose() {
    onClose();
    if (setFinishRenderPaypalButtons) {
      setFinishRenderPaypalButtons(false);
    }
  }


  return <ConfirmModal
    isOpen={isOpen}
    title={t('paypalPayment')}
    noAction={handleClose}
    sx={{
      height: paypalOrderId ? '80dvh' : '360px',
      duration: 300,
      width: '500px',
      maxWidth: "95dvw",
      transition: "all 0.3s ease-in-out",
      overflowY: 'scroll'
    }}
    modalProps={{
      open: isOpen,
      disableEscapeKeyDown: true,
      disableAutoFocus: true,
      disableEnforceFocus: true,
      disableRestoreFocus: true,
      onBackdropClick: (e: any) => e.stopPropagation(),
      children: <></>
    }}
  >
    <Box
      // id="paypal-button"
      ref={paypalRef}
      width="100%"
      sx={{
        display: paypalPaymentApproved ? 'none' : 'flex',
        justifyItems: "center",
        justifyContent: 'center',
        alignItems: 'center'
      }} />
    {
      !finishRenderPaypalButtons && (
        <Box
          position="absolute"
          alignItems="center"
          justifyContent="center"
          gap={2}
          sx={{
            zIndex: 999,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 'fit-content',
            height: 'fit-content',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            padding: '8px',
            borderRadius: '999px',
          }}
        >
          <CircularProgress />
        </Box>
      )
    }

    {
      paypalPaymentApproved && (
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <CircularProgress />
          <Typography>
            {t('common:bookingConfirmed')}
          </Typography>
        </Box>
      )
    }
    {/* Start Script for Paypal */}
    <Script
      id="paypal-script"
      src={`https://www.paypal.com/sdk/js?client-id=${process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID}&currency=USD`}
    />
    {/* End Script for Paypal */}
  </ConfirmModal >
}